import React from "react";
import Marcador from "../marcador/index";
import { BsCheckLg } from "react-icons/bs";
import SeguroParaTodos from "../../footer/seguroParaTodo/index";
import Container from "./styled";

export default function Contrataste({ planSelected }) {

  console.log(planSelected)

  return (
    <Container className="topInOpacity5">
      <Marcador title="hidden" pasoDos="hecho" pasoTres="hecho"></Marcador>
      <div className="contratasteContainer opacidad04">
        <h2>
          <span>
            <BsCheckLg></BsCheckLg>
          </span>
          ¡Contrataste con éxito!
        </h2>
        <div className="dataContainer">
          <div className="dataText">
            <div className="dataSeguro">
              <img
                alt="Logo Seguro"
                src={planSelected.logo}
              ></img>
              <div>
                <p>{planSelected.seguro}</p>
                <p>{planSelected.plan}</p>
              </div>
            </div>
            <p id="textoNombre">
              Nombre un Ejecutivo se contactará con vos en las próximas horas
              para finalizar la contratación.
            </p>
            <p id="textoDatos">
              Para agilizar el proceso prepará los siguientes datos:{" "}
            </p>
            <div className="datosPreparados">
              {/* Preparado */}
              <div>
                <span>
                  <BsCheckLg></BsCheckLg>
                </span>
                <p>Cantidad de cambios de Velocidad</p>
              </div>
              {/* Preparado */}
              <div>
                <span>
                  <BsCheckLg></BsCheckLg>
                </span>
                <p>Rodado</p>
              </div>
              {/* Preparado */}
              <div>
                <span>
                  <BsCheckLg></BsCheckLg>
                </span>
                <p>Marca y modelo de la transmisión</p>
              </div>
              {/* Preparado */}
              <div>
                <span>
                  <BsCheckLg></BsCheckLg>
                </span>
                <p>Marca de las ruedas</p>
              </div>
              {/* Preparado */}
              <div>
                <span>
                  <BsCheckLg></BsCheckLg>
                </span>
                <p>Material y tamaño de cuadro</p>
              </div>
            </div>
            <div className="datosPreparados">
              {/* Preparado */}
              <div>
                <span>
                  <BsCheckLg></BsCheckLg>
                </span>
                <p>
                  Foto de la bicicleta del lado derecho, con un cartel
                  manuscrito indicando la fecha de hoy
                </p>
              </div>
              {/* Preparado */}
              <div>
                <span>
                  <BsCheckLg></BsCheckLg>
                </span>
                <p>
                  Foto del número de serie, que se encuentra debajo de la
                  pedalera
                </p>
              </div>
              {/* Preparado */}
              <div>
                <span>
                  <BsCheckLg></BsCheckLg>
                </span>
                <p>
                  Foto de la factura de compra o presupuesto realizado por una
                  bicicletería
                </p>
              </div>
            </div>
          </div>
          <img alt="Ilustración" src="images/steps/contrataste.png"></img>
        </div>
        <div className="dataContacto">
          <p>Horario de atención: 9hs a 20hs.</p>
          <p>0810-220-2373 / (011) 5263-2373</p>
        </div>
      </div>
      <SeguroParaTodos page="contrataste"></SeguroParaTodos>
    </Container>
  );
}
